<template>
	<div style="overflow-y: auto;overflow-x: hidden;height: calc(100vh - 90px);">
		<div>
			<Row style="margin-top: 20px;">
				<Col span=24>
				<Card
					style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;height:70px;white;color: #000000;background-color: white;">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;">
						<FormItem prop="trackName" label="充电站:" :label-width="100">
							<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList"
									:value="item.StationId">{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<FormItem prop="trackName" label="查询类型:" :label-width="100">
							<Select placeholder="查询类型" style="width: 70px;" @on-change="changelegend_data"
								v-model="formInline.dateType">
								<!-- <Option value="date">按日</Option> -->
								<Option value="month">按月</Option>
								<Option value="year">按年</Option>
							</Select>
						</FormItem>
						<FormItem label="选择时间" :label-width='70'>
							<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date"
								v-model="formInline.QueryTime"></DatePicker>
						</FormItem>
						<FormItem v-if="Control.select">
							<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
						</FormItem>
					</Form>
				</Card>
				</Col>
			</Row>
			<Card
				style="margin-bottom: 10px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;height: 9%;">
				<Row>
					<Col span="5">
					<Tag color="success" type="dot">直流设备数量 {{Summary.DcAmount}} 个</Tag>
					</Col>
					<Col span="5">
					<Tag color="primary" type="dot">交流设备数量 {{Summary.AcAmount}} 个</Tag>
					</Col>
					<Col span="4">
					<Tag color="warning" type="dot">总功率 {{Summary.TotolPower}} KW</Tag>
					</Col>
					<Col span="5">
					<Tag color="default" type="dot">合计充电量 {{Summary.ChargeKwh}} KWh</Tag>
					</Col>
					<Col span="5">
					<Tag color="error" type="dot">合计充电收入 {{Summary.ChargeCost}} 元</Tag>
					</Col>
				</Row>
			</Card>
			<Row class="incomeStyle" style="margin-top: 10px;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						收入趋势
					</p>
					<div class="echartDiv" id="echart1"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						分时收入
					</p>
					<div class="echartDiv" id="echart2"></div>
				</Card>
				</Col>
			</Row>
			<Row class="incomeStyle" style="margin-top: 10px;" :gutter="16">
				<Col span=24>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						场站利用率
					</p>
					<div class="echartDiv" id="echart3"></div>
				</Card>
				</Col>
				<!-- <Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						充电收入（元）
					</p>
					<div class="echartDiv" id="echart4"></div>
				</Card>
				</Col> -->
			</Row>
			<Row class="incomeStyle" style="margin-top: 10px;" :gutter="16">
				<Col span=24>
				<Card class="cardStyle" style="height: 600px;">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						设备{{formInline.dateType=='month'?'月':'年'}}排行
					</p>
					<Table :columns="columns1" :data="data1" ref="table"></Table>
				</Card>
				</Col>
			</Row>
		</div>
	</div>
</template>

<script>
	import echart from '../../../js/echarts_hot.js'
	import dateFormat from '../../../../public/js/comm.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				BreadcrumbList: ['场站监控', '>>', '收入监控'],
				Control: {},
				formInline: {
					StationId: 0,
					QueryTime: new Date('2024-01-01'),
					dateType: 'month'
				},
				//充电设备总计
				Summary: {
					DcAmount: 0,
					AcAmount: 0,
					TotolPower: 0,
					ChargeKwh: 0,
					ChargeCost: 0,
				},
				//图表数据充电次数
				lineEchart: {
					legend_data: ['电费收入(元)', '服务费费收入(元)', '总收入(元)'],
					seriesData: [{
							name: '电费收入(元)',
							type: 'bar',
							stack: '收入',
							data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '服务费费收入(元)',
							type: 'bar',
							stack: '收入',
							data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '总收入(元)',
							type: 'bar',
							stack: '总收入',
							data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
						},
					],
					style: {
						color: "black"
					},
					TimePoins: ['1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号', '11号', '12号', '13号', '14号']
				},
				//图表数据充电次数
				lineEchart2: {
					legend_data: ['电费总收入(元)', '服务费费收入(元)', '电量(度)'],
					seriesData: [{
							name: '电费总收入(元)',
							type: 'bar',
							stack: '收入',
							data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
						},
						// {
						// 	name: '服务费费收入(元)',
						// 	type: 'bar',
						// 	stack: '收入',
						// 	data: [220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290, 330, 310]
						// }, 
						{
							name: '电量(度)',
							type: 'line',
							stack: '度',
							data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: ['1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号', '11号', '12号', '13号', '14号']
				},
				//图表数据充电次数
				lineEchart3: {
					legend_data: ['场站利用率'],
					seriesData: [{
						name: '场站利用率(%)',
						type: 'line',
						stack: '当前',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: ['1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号', '11号', '12号', '13号', '14号']
				},
				//图表数据充电次数
				lineEchart4: {
					legend_data: ['当前', '上一日'],
					seriesData: [{
						name: '当前',
						type: 'line',
						stack: '当前',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					}, {
						name: '上一日',
						type: 'line',
						stack: '上一日',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: ['1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号', '11号', '12号', '13号', '14号']
				},
				columns1: [{
					title: '设备编码',
					key: 'ConnectorNo',
				}, {
					title: '设备名称',
					key: 'EquipmentName',
				}, {
					title: '充电量(度)',
					key: 'ChargeKwh'
				}, {
					title: '充电收入(元)',
					key: 'ChargeCost'
				}, {
					title: '充电时长(小时)',
					key: 'ChargeDuration'
				}, {
					title: '所属场站',
					key: 'StationName'
				}],
				data1: [],
			}
		},
		created() {
			this.handleSubmit();
		},
		activated() {

			let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			this.Control = col.control
			console.log(col.control);
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		destroyed() {
			echart.disposeEchart(null)
		},
		mounted() {
			//解决刷新页面有时会忽略侧边栏宽度，图表超出容器
			setTimeout(() => {
				echart.initLinechart3("echart1", this.lineEchart);
				echart.initLinechart3("echart2", this.lineEchart2);
				echart.initLinechart3("echart3", this.lineEchart3);
				//echart.initLinechart3("echart4", this.lineEchart4);
			}, 20)
		},
		deactivated() {
			this.$destroy();
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				//echarts数据
				let url = '';
				//echarts 利用率数据
				let url4 = '';
				//总结数据
				let url2 = '';
				//table数据
				let url3 = '';
				let parms = {
					StationId: _this.formInline.StationId,
					QueryTime: _this.formInline.QueryTime == '' ? dateFormat.formatDate(new Date(), 'yyyy-MM-dd') :
						dateFormat.formatDate(
							new Date(_this.formInline.QueryTime), 'yyyy-MM-dd')
				};
				switch (_this.formInline.dateType) {
					case 'date':
						url = webapi.base_api_url + "/Operations/GetRevenueDaily";
						_this.axiosMethod(url, parms, "echart")
						url2 = webapi.base_api_url + '/Statistics/GetDailyStationSummary';
						_this.axiosMethod(url2, parms, "Summary")
						url3 = webapi.base_api_url + '/Statistics/GetDailyEquipmenRank';
						_this.axiosMethod(url3, parms, "table")
						url4 = webapi.base_api_url + '/Operations/GetUserRateDaily';
						_this.axiosMethod(url4, parms, "rate")
						break;
					case 'year':
						url = webapi.base_api_url + "/Operations/GetRevenueYearly";
						_this.axiosMethod(url, parms, "echart")
						url2 = webapi.base_api_url + '/Statistics/GetYearlyStationSummary';
						_this.axiosMethod(url2, parms, "Summary")
						url3 = webapi.base_api_url + '/Statistics/GetYearlyEquipmenRank';
						_this.axiosMethod(url3, parms, "table")
						url4 = webapi.base_api_url + '/Operations/GetUserRateYearly'
						_this.axiosMethod(url4, parms, "rate")
						break;
					case 'month':
						url = webapi.base_api_url + "/Operations/GetRevenueMonthly";
						_this.axiosMethod(url, parms, "echart")
						url2 = webapi.base_api_url + '/Statistics/GetMonthlyStationSummary';
						_this.axiosMethod(url2, parms, "Summary")
						url3 = webapi.base_api_url + '/Statistics/GetMonthlyEquipmenRank';
						_this.axiosMethod(url3, parms, "table")
						url4 = webapi.base_api_url + '/Operations/GetUserRateMonthly'
						_this.axiosMethod(url4, parms, "rate")
						break;
				}
			},
			axiosMethod: function(url, parms, type) {
				const _this = this;
				_this.$axios.post(url, parms, {
				}).then(res => {
					console.log("axiosMethod")
					console.log(type)
					//console.log(res)
					if (res.data.Code == 0) {
						switch (type) {
							case "echart":
								_this.dealEchart(res)
								break;
							case "Summary":
								_this.dealSummary(res)
								break;
							case "table":
								_this.dealTable(res)
								break;
							case "rate":
								_this.dealRate(res)
								break;
							default:
								break;
						}
					}
				})
			},
			dealEchart: function(res) {
				const _this = this;
				// let MyTimePoins = []
				// switch (_this.formInline.dateType) {
				// 	case 'date':
				// 		res.data.Data.Curves.TimePoins.forEach(function(time) {
				// 			MyTimePoins.push(time.split(" ")[1] + ":00")
				// 		})
				// 		break;
				// 	case 'year':
				// 		res.data.Data.Curves.TimePoins.forEach(function(time) {
				// 			MyTimePoins.push(time.split("-")[1] + "月")
				// 		})
				// 		break;
				// 	case 'month':
				// 		res.data.Data.Curves.TimePoins.forEach(function(time) {
				// 			MyTimePoins.push(time.split("-")[2] + "号")
				// 		})
				// 		break;
				// };
				_this.lineEchart.TimePoins = res.data.Data.Time
				_this.lineEchart.seriesData[0].data = res.data.Data.ChargeFee
				_this.lineEchart.seriesData[1].data = res.data.Data.ServiceFee
				_this.lineEchart.seriesData[2].data = res.data.Data.TotalFee
				_this.lineEchart2.TimePoins = res.data.Data.Time
				// _this.lineEchart2.seriesData[0].data = res.data.Data.ChargeFee
				// _this.lineEchart2.seriesData[1].data = res.data.Data.ServiceFee
				// _this.lineEchart2.seriesData[2].data = res.data.Data.Kwh 
				_this.lineEchart2.seriesData[0].data = res.data.Data.TotalFee
				_this.lineEchart2.seriesData[1].data = res.data.Data.Kwh
				// _this.lineEchart3.TimePoins = res.data.Data.Time
				// _this.lineEchart3.seriesData[0].data = res.data.Data.Curves.ChargeDuration.Current
				// _this.lineEchart3.seriesData[1].data = res.data.Data.Curves.ChargeDuration.Previos
				// _this.lineEchart4.TimePoins = MyTimePoins
				// _this.lineEchart4.seriesData[0].data = res.data.Data.Curves.ChargeRevenue.Current
				// _this.lineEchart4.seriesData[1].data = res.data.Data.Curves.ChargeRevenue.Previos
				echart.upEchartOpt(null);
			},
			dealRate: function(res) {
				const _this = this;
				_this.lineEchart3.TimePoins = res.data.Data.Time
				_this.lineEchart3.seriesData[0].data = res.data.Data.UserRate
				echart.upEchartOpt(null);
			},
			dealSummary: function(res) {
				console.log("dealSummary")
				console.log(res)
				this.Summary = res.data.Data.Curves
			},
			dealTable: function(res) {
				console.log("dealTable")
				console.log(res)
				this.data1 = res.data.Data
			},
			changelegend_data: function() {
				const _this = this
				// switch (_this.formInline.dateType) {
				// 	case 'date':
				// 		_this.lineEchart.legend_data = ['当前', '上一日'];
				// 		_this.lineEchart.seriesData[1].name = '上一日';

				// 		_this.lineEchart2.legend_data = ['当前', '上一日'];
				// 		_this.lineEchart2.seriesData[1].name = '上一日';

				// 		_this.lineEchart3.legend_data = ['当前', '上一日'];
				// 		_this.lineEchart3.seriesData[1].name = '上一日';

				// 		_this.lineEchart4.legend_data = ['当前', '上一日'];
				// 		_this.lineEchart4.seriesData[1].name = '上一日';
				// 		break;
				// 	case 'year':
				// 		_this.lineEchart.legend_data = ['当前', '上一年'];
				// 		//_this.$set(_this.lineEchart.legend_data,1,'上一年')
				// 		_this.lineEchart.seriesData[1].name = '上一年';

				// 		_this.lineEchart2.legend_data = ['当前', '上一年'];
				// 		_this.lineEchart2.seriesData[1].name = '上一年';

				// 		_this.lineEchart3.legend_data = ['当前', '上一年'];
				// 		_this.lineEchart3.seriesData[1].name = '上一年';

				// 		_this.lineEchart4.legend_data = ['当前', '上一年'];
				// 		_this.lineEchart4.seriesData[1].name = '上一年';
				// 		break;
				// 	case 'month':
				// 		_this.lineEchart.legend_data = ['当前', '上一月'];
				// 		_this.lineEchart.seriesData[1].name = '上一月';

				// 		_this.lineEchart2.legend_data = ['当前', '上一月'];
				// 		_this.lineEchart2.seriesData[1].name = '上一月';

				// 		_this.lineEchart3.legend_data = ['当前', '上一月'];
				// 		_this.lineEchart3.seriesData[1].name = '上一月';

				// 		_this.lineEchart4.legend_data = ['当前', '上一月'];
				// 		_this.lineEchart4.seriesData[1].name = '上一月';
				// 		break;
				// }
			}
		}
	}
</script>

<style>
	.incomeStyle .cardStyle {
		/* margin-bottom: 20px !important; */
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 100% !important;
		color: #000000;
		background-color: #ffffff !important;
		height: 334px;
	}

	.incomeStyle .cardStyle p {
		text-align: left;
		color: #000000 !important;
	}

	.cardStyle .echartDiv {
		height: 250px;
	}

	.echartDiv {
		background-color: #ffffff;
	}
</style>
